import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            fullname:'',//用户姓名
            usertype:'',//用户类型
            organizationids:'',//所属组织
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
        //查询App列表信息
        selectApp(context, payload) {
            payload.type = 'app/queryapp'
            return D.select({
                ...payload
            })
        },
        addApp(context, payload) {
            payload.type = 'app/addapp'
            return D.add({
                ...payload
            })
        },
        editApp(context, payload) {
            payload.type = 'app/editapp'
            return D.edit({
                ...payload
            })
        },
        deleteApp(context, payload) {
            payload.type = 'app/deleteapp'
            return D.del({
                ...payload
            }).then(response => {
                context.dispatch('selectSys')
                return response
            })
        },
        selectAppNode(context, payload) {
            payload.type = 'app/selectAppNode'
            return D.select({
                ...payload
            })
        },
        refreshAppNode(context, payload) {
            return D.edit({
                ...payload
            })
        },
        refreshOneAppNode(context, payload) {
            return D.edit({
                ...payload
            })
        },
        getAppItem(context, payload) {
            return D.select({
                ...payload
            })
        },
        queryAppServicekeyBind(context, payload) {
            return D.select({
                ...payload
            })
        },
        deleteAppServicekeyBind(context, payload) {
            return D.del({
                ...payload
            })
        },
        addAppServicekeyBind(context, payload) {
            return D.add({
                ...payload
            })
        },
        updateAppServicekeyBind(context, payload) {
            return D.edit({
                ...payload
            })
        },
        getAllAppServicekeyBind(context, payload) {
            return D.select({
                ...payload
            })
        },

        getAppDomainBind(context, payload) {
            return D.select({
                ...payload
            })
        },
        addAppDomainBind(context, payload) {
            return D.add({
                ...payload
            })
        },
        deleteAppDomainBind(context, payload) {
            return D.del({
                ...payload
            })
        },
        
    }
}